const mutations = {
  set_menu_list: (state, menuList) => {
    state.menu.menuList = menuList
  },
  set_menu_detail_list: (state, menuDetailList) => {
    state.menu.menuDetailList = menuDetailList
    // console.log(menuDetailList);
  },
  set_is_view: (state, isView) => {
      state.menu.isView = isView
  },
  set_is_active: (state, isAction) => {
      state.menu.isAction = isAction
      if(isAction==5){
        state.menu.isView=true
      }else{
        state.menu.isView=false
      }
  },
}
export default mutations